import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { WegetThreeCanvas } from './wegets/weget-three-canvas/weget-three-canvas';
import { useState } from 'react';
import { WegetPalletList } from './wegets/weget-pallet-list/WegetPalletList';

const BinPacking3D = require('binpackingjs').BP3D;

const { Item, Bin, Packer } = BinPacking3D;

const GOOGLE_SHEETS_API_KEY = 'AIzaSyCCs_HLQT2VYPkhVpw9ORU1AGF-w2Zxhj0';
const spreadsheetId = '1C71w_bB3RdJVyjR6dnq1MfmpTCC03LS7TDCqpP6LSxw';

const PALLET_WIDTH = 1100;
const PALLET_DEPTH = 1100;
const PALLET_HEIGHT = 1800;
const EXTRA_ITEM_MAX_CBM = 0.5;


export function MainView(props) {
    const [palletDatas, setPalletDatas] = useState(null);
    const [selectedPalletData, setSelectedPalletData] = useState(null);

    const handleFulfill = async () => {
        const purchasingItems = await getPurchasingItemsForSpreadsheets();
        setPalletDatas(await calculatePallet(purchasingItems));
    }

    const handleSelectPalletData = (palletData) => {
        setSelectedPalletData(palletData);
    }

    console.log(palletDatas)
    return (
        <>
            <button onClick={() => handleFulfill()}>실행</button>
            <WegetPalletList
                palletDatas={palletDatas}
                selectedPalletData={selectedPalletData}
                onSelectPalletData={handleSelectPalletData}
            />
            {/* <WegetThreeCanvas
                selectedPalletData={selectedPalletData}
            /> */}
        </>
    );
}

async function getPurchasingItemsForSpreadsheets() {
    const data = await getSpreadsheetsData();
    const items = [];

    data.forEach(r => {
        items.push({
            purchasingItemId: uuidv4(),
            optionCode: r[0],
            productName: r[2],
            optionName1: r[3],
            optionName2: r[4],
            waybillNumber: r[7],
            boxQuantity: r[9],
            boxWidth: r[11] * 10,
            boxDepth: r[12] * 10,
            boxHeight: r[13] * 10,
            boxCBM: (r[11] * r[12] * r[13]) / 1000000
        })
    })

    return items;
}

async function calculatePallet(purchasingItems) {
    const normalItems = [];
    const heteromorphicItems = [];
    let extraItems = [];

    purchasingItems.forEach(r => {
        const boxSize = [r.boxWidth, r.boxDepth, r.boxHeight]; // mm 단위로 변환

        boxSize.sort((a, b) => b - a); // 가장 긴 부분을 width, 두번째로 긴 부분은 depth, 가장 짧은 부분을 height로 정렬

        if ((boxSize[0] > PALLET_WIDTH && boxSize[0] > PALLET_DEPTH) || (boxSize[1] > PALLET_WIDTH && boxSize[1] > PALLET_DEPTH)) {
            heteromorphicItems.push({
                ...r,
                boxWidth: boxSize[0],
                boxDepth: boxSize[1],
                boxHeight: boxSize[2],
            })
        } else {
            normalItems.push({
                ...r,
                boxWidth: boxSize[0],
                boxDepth: boxSize[1],
                boxHeight: boxSize[2],
            })
        }
    });

    let pallets = [];

    normalItems.sort((a, b) => {
        if (`${a.productName}_${a.optionName1}_${a.optionName2}` < `${b.productName}_${b.optionName1}_${b.optionName2}`) return -1;
        if (`${a.productName}_${a.optionName1}_${a.optionName2}` > `${b.productName}_${b.optionName1}_${b.optionName2}`) return 1;
        return 0;
    });

    const normalItemsAggregations = [];
    let queue = [];

    normalItems.forEach(normalItem => {
        if (queue.length <= 0) {
            queue.push(normalItem);
            return;
        }

        if (`${queue[0].productName}` === `${normalItem.productName}`) {
            queue.push(normalItem);
        } else {
            normalItemsAggregations.push({
                productName: queue[0].productName,
                subItems: [...queue]
            })

            queue = [{ ...normalItem }];
        }
    })

    if (queue?.length > 0) {
        normalItemsAggregations.push({
            productName: queue[0].productName,
            subItems: [...queue]
        })
    }

    normalItemsAggregations.forEach(normalItemsAggregation => {
        let totalCBM = 0;
        const devidedSubItems = normalItemsAggregation.subItems.reduce((prev, curr) => {
            totalCBM += (curr.boxCBM * curr.boxQuantity);

            if (!curr.boxQuantity || curr.boxQuantity <= 0) {
                return prev.concat({ ...curr, boxQuantity: 0 })
            }

            const items = [];

            for (let i = 0; i < curr.boxQuantity; i++) {
                items.push({
                    ...curr,
                    boxQuantity: 1
                })
            }

            return prev.concat([...items])
        }, []);

        if (totalCBM < EXTRA_ITEM_MAX_CBM) {
            extraItems = extraItems.concat([...devidedSubItems]);
        } else {
            const packaingResult = myPackingFunction(devidedSubItems, pallets, 'NORMAL');
            if (packaingResult?.length > 0) {
                pallets = pallets.concat(packaingResult);
            }
        }
    })

    const extraItemsPackingResult = myPackingFunction(extraItems, pallets, 'EXTRA');
    if (extraItemsPackingResult?.length > 0) {
        pallets = pallets.concat(extraItemsPackingResult);
    }

    const heteromorphicItemsPackingResult = myPackingFunction(heteromorphicItems, pallets, 'HETEROMORPHIC');
    if (heteromorphicItemsPackingResult?.length > 0) {
        pallets = pallets.concat(heteromorphicItemsPackingResult);
    }

    return pallets;
}
async function getSpreadsheetsData() {
    const sheetName = '시트1';

    const sheetItemList = await axios.get(`https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${sheetName}?key=${GOOGLE_SHEETS_API_KEY}`)
        .then(res => {
            if (res.status === 200 && res.data?.values && res.data?.values?.length > 0) {
                const values = res.data.values;
                return values?.filter((r, index) => index !== 0 && r[2]);
            }
        })
        .catch(err => {
            console.log(err);
        })

    return sheetItemList;
}

function myPackingFunction(items, originPallet, type = 'NORMAL') {

    let targetItems = items.map(r => {
        return {
            ...r,
            id: uuidv4()
        }
    })
    let pallets = [];
    let palletIdx = 1;
    let trierCount = 0;

    while (targetItems?.length > 0) {
        let packer = new Packer();
        let pallet = new Bin("PALLET", PALLET_WIDTH, PALLET_DEPTH, PALLET_HEIGHT);

        packer.addBin(pallet);

        targetItems.forEach(r => {
            const itemWidth = r.boxQuantity <= 0 ? 0 : r.boxWidth;
            const itemDepth = r.boxQuantity <= 0 ? 0 : r.boxDepth;
            const itemHeight = r.boxQuantity <= 0 ? 0 : r.boxHeight;
            packer.addItem(new Item(`${r.id}`, itemWidth, itemHeight, itemDepth));
        })

        // pack items into bin1
        packer.pack();
        let palletedIds = pallet.items?.map(r => r.name);
        let unfitedItemIds = packer.unfitItems?.map(r => r.name);

        const palletedItems = targetItems.filter(r => palletedIds.includes(r.id)).map(r => {
            let newItem = { ...r };
            return newItem
        });

        if (palletedItems?.length > 0) {
            pallets = pallets.concat({
                type: type,
                palletNumber: originPallet.length + palletIdx,
                devidedSubItems: palletedItems,
                fitedBoxs: pallet.items
            })
        }

        if (unfitedItemIds?.length <= 0) {
            break;
        }

        targetItems = targetItems.filter(r => unfitedItemIds.includes(r.id));
        palletIdx++;
        trierCount++;

        if (trierCount > 500) {
            console.log('trierCount', trierCount)
            break;
        }

        // // item1, item2, item3
        // console.log(palletedIds);

        // // items will be empty, all items was packed
        // console.log(packer.items);

        // // unfitItems will be empty, all items fit into bin1
        // console.log(packer.unfitItems)
    }

    return pallets;
}